// header dropdown menu script start
document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header__inline-menu > ul > li');
  let activeMenuItem = null; 
  menuItems.forEach((item, index) => {
    const detailsElement = item.querySelector('details');
    if (!detailsElement) {
      return;
    }
    item.addEventListener('mouseenter', () => {
      if (activeMenuItem && activeMenuItem !== item) {
        const previousDetailsElement = activeMenuItem.querySelector('details');
        if (previousDetailsElement) previousDetailsElement.removeAttribute('open');
      }
      detailsElement.setAttribute('open', true);
      activeMenuItem = item; 
    });
 
    item.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!item.matches(':hover')) {
          detailsElement.removeAttribute('open');
          if (activeMenuItem === item) activeMenuItem = null; 
        } 
      }, 500); // Adjust delay as needed
    });
  });
});

// header dropdown menu script End

var swiper = new Swiper(".coll_pro_img", {
      pagination: {
        el: ".swiper-pagination",
         clickable: true,
      },
    });
   
  var ctswiper = new Swiper(".ct_mySwiper", {
    spaceBetween: 0,
    slidesPerView: 1,
   cssMode: true,
    watchSlidesProgress: true,
  
  });
  var swiper2 = new Swiper(".ctmySwiper2", {
    spaceBetween: 0,
   cssMode: true,

    navigation: {
      nextEl: ".oue-arrow-next",
      prevEl: ".oue-arrow-prew",
    },
    thumbs: {
      swiper: ctswiper,
    },
  });

// let cart_swiper;

// function initCartSwiper() {
//   if (cart_swiper) {
//     cart_swiper.destroy(true, true);
//   }

//   const slider = document.querySelector('.cart_product_list');
//   if (slider) {
//     cart_swiper = new Swiper(slider, {
//       spaceBetween: 10,
//       navigation: false,
//       slidesPerView: 2.2,
//       pagination: false,
//       breakpoints: {
//         750: {
//           spaceBetween: 19,
//         }
//       },
//     });
//     console.log('Swiper initialized');
//   }
// }

// initCartSwiper();

$('.ct_benefits_title').each(function () {
  var html = $(this).html().trim();
  var words = html.split(/\s+/);
  if (words.length >= 2) {
    var firstTwo = words.slice(0, 2).join(' ');
    var rest = words.slice(2).join(' ');
    var updatedHtml = '<span>' + firstTwo + '</span> ' + rest;
    $(this).html(updatedHtml);
  }
});

$(document).on('click','.size_chart_button',function(){
  $('body').addClass('size_popup_open');
});
$(document).on('click','.size_chart_close_btn',function(){
  $('body').removeClass('size_popup_open');
});
$(document).on('click','.size_chart_overlay',function(){
  $('body').removeClass('size_popup_open');
});

$(document).on('click','.size_chart_tab_item',function(){
  $('.size_chart_tab_item').removeClass('active');
  $(this).addClass('active');
  let tab_active = $(this).data('tab');
  $('.size_chart_tab_content_item').removeClass('active');
  $('.size_chart_tab_content_item').each(function() {
    if ($(this).data('tab-content') === tab_active) {
      $(this).addClass('active');
    }
  });
});
$(document).on('click','.size_chart_inch_cm_item',function(){
  $('.size_chart_inch_cm_item').removeClass('active');
  $(this).addClass('active');
  let inner_tab_active = $(this).data('inner-tab');
  $('.size_chart_inch_cm_content_item').removeClass('active');
  $('.size_chart_inch_cm_content_item').each(function() {
    if ($(this).data('inner-content') === inner_tab_active) {
      $(this).addClass('active');
    }
  });
});


// Hero slider script start
var ct_hero_slider = new Swiper(".ct_hero_slider_wrapper", {
    slidesPerView: 1, 
    loop: true,
     autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".ct_hero_slider_pagination.swiper-pagination",
        clickable: true,
      }
  });
  // Hero slider script End



  $(window).on('load', function() { $('body').addClass('loaded-done'); });